export type LineupStyle = 'inline' | 'forced_inline' | 'spread';

// 'inline' collides with the Tailwind `inline` utility (display: inline)
export const lineupStyleClassName = (lineupStyle?: LineupStyle) =>
  lineupStyle === 'inline' ? 'isInline' : lineupStyle;
